type RequestHeaders = Record<string, string>;

interface AuthTokens {
  /** Darwin's JWT; null without a session. */
  token: string | null;
  /** The Identity access token; null while the user has none (Identity off or not signed in yet). */
  identityToken: string | null;
}

/**
 * Headers of every GraphQL request: Darwin's token, empty without a session, and the Identity token
 * when the user has one, so the backend gets the token the front keeps renewed instead of the one
 * Darwin's token carried when it was issued.
 */
export const buildAuthHeaders = (
  headers: RequestHeaders | undefined,
  { token, identityToken }: AuthTokens,
): RequestHeaders => ({
  ...headers,
  token: token ?? "",
  ...(identityToken ? { "identity-token": identityToken } : {}),
});
